import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { InsuranceBuyingStepRoute } from 'common/enums/app-route-path.enum';
import InsuranceBuyingRouteWrapper from 'components/InsuranceBuyingRouteWrapper';
import Stepper from 'components/InsuranceBuyingStepper';
import InsurancePaymentRoutesGuard from 'common/guards/InsurancePaymentRoutesGuard';
import Loading from 'components/Loading';
import CarAppaCalculationProvider from 'features/common/calculators/car/appa/providers/car-appa-calculation.provider';
import CarAppaCalculationContext from 'features/common/calculators/car/appa/contexts/car-appa-calculation.context';
import { CAR_INSURANCE_BUYING_STEPS } from 'features/insurances/features/car/constants';
import { InsuranceTypes } from 'common/enums';
import AppaBuyingCalculator from './AppaBuyingCalculator';

const LazyAppaBuyingDetails = lazy(() => import('./AppaBuyingDetails'));
const LazyAppaBuyingPayment = lazy(() => import('./AppaBuyingPayment'));
const LazyAppaBuyingPaymentInfo = lazy(() => import('./AppaBuyingPaymentInfo'));

function AppaBuyingRoutesWrapper() {
  const location = useLocation();

  return (
    <InsuranceBuyingRouteWrapper
      stepper={
        <Stepper<InsuranceBuyingStepRoute> data={CAR_INSURANCE_BUYING_STEPS} />
      }
      outlet={
        <CarAppaCalculationProvider defaultState={location.state?.priceData}>
          <CarAppaCalculationContext.Consumer>
            {(props) => (
              <Suspense fallback={<Loading height={300} size="large" />}>
                <InsurancePaymentRoutesGuard
                  type={InsuranceTypes.APPA}
                  /* eslint-disable-next-line react/prop-types */
                  isPriceDataValid={!!props?.price}
                >
                  <Outlet />
                </InsurancePaymentRoutesGuard>
              </Suspense>
            )}
          </CarAppaCalculationContext.Consumer>
        </CarAppaCalculationProvider>
      }
    />
  );
}

function AppaBuyingRoutes() {
  return (
    <Routes>
      <Route element={<AppaBuyingRoutesWrapper />}>
        <Route
          path={InsuranceBuyingStepRoute.CALCULATOR}
          element={<AppaBuyingCalculator />}
        />
        <Route
          path={InsuranceBuyingStepRoute.DETAILS}
          element={<LazyAppaBuyingDetails />}
        />
        <Route
          path={InsuranceBuyingStepRoute.PAYMENT}
          element={<LazyAppaBuyingPayment />}
        />
        <Route
          path={InsuranceBuyingStepRoute.PAYMENT_INFO}
          element={<LazyAppaBuyingPaymentInfo />}
        />
        <Route
          path="*"
          element={<Navigate to={InsuranceBuyingStepRoute.CALCULATOR} />}
        />
      </Route>
    </Routes>
  );
}

export default AppaBuyingRoutes;
